module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURf///0dwTP///////////////////////////////////6NZO5wAAAALdFJOU/8Ad4leFsnnqz4mHLip/gAAAAlwSFlzAAAASAAAAEgARslrPgAAAJBJREFUKM/d0DEOgkAQBdBvJBg7P2KCJZwAwwXgCDTUNPY2NHQcwRtoxTWZ2VlJVjpLf/XnZWeLQVoEaVAjSLSFDHG1pscE9njS54qYYIfxAzMGgcvj0Nos7S0gfjfocKSCbrq43wRYY9I5Q0SDBHuFErkHqQ2ZGsMe78iXLTqgQRvCyde/g/L2BZof4OxOygXW/Sg2zw/S4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/search/search_1.png
// module id = 97
// module chunks = 0